"use client";

import Footer from "@/components/custom/footer";

export default function Page() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <main className="flex flex-col container mx-auto pt-12 px-4 md:px-8 py-3 items-start min-h-[calc(100vh-160px)]">
        <h1 className="text-2xl font-bold mb-4">Disclaimer</h1>
        <p className="text-base text-gray-600 dark:text-gray-400 mb-6">
          De berekeningen van cijfersberekenen.nl worden uiterst zorgvuldig
          uitgevoerd. Ondanks het grootste vertrouwen in de gehanteerde
          formules, kan cijfersberekenen.nl de juistheid van de gepubliceerde
          informatie nooit garanderen. Het gebruik van de website geschiedt
          daarom volledig op het risico en de verantwoordelijkheid van de
          gebruiker. © Copyright 2014-{currentYear}. Alle rechten voorbehouden.
        </p>
      </main>
      <Footer />
    </>
  );
}
